import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import { logIn as logInRequest } from '../services/LogIn';
import { setPassword as setPasswordRequest } from '../services/Password';
import { setAccount, unsetAccount } from '../services/Account';
import { fetchDomains } from './domains';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    is_logged_in: Boolean(Cookies.get('name') && Cookies.get('is_logged_in')),
    account_id: Number(Cookies.get('account_id')) || 0,
    current_domain: '',
  },
  reducers: {
    setIsLoggedIn: (state, { payload }) => { state.is_logged_in = payload; },
    setAccountId: (state, { payload }) => { state.account_id = payload; },
    setCurrentDomain: (state, { payload }) => { state.current_domain = payload; },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDomains.fulfilled, (state, { payload }) => {
      state.current_domain = payload.current_domain;
    });
  },
});

export const { setIsLoggedIn, setAccountId } = appSlice.actions;
export default appSlice.reducer;

export const chooseDomain = (domain) => (dispatch) => {
  Cookies.set('current_domain', domain);
  dispatch(appSlice.actions.setCurrentDomain(domain));
};

export const logIn = (username, password) => async (dispatch) => {
  const response = await logInRequest(username, password);
  if (response.success) {
    dispatch(setIsLoggedIn(true));
  }
  return response;
};

export const setPassword = (password, code) => async (dispatch) => {
  const response = await setPasswordRequest(password, code);
  if (response.success) {
    dispatch(setIsLoggedIn(true));
  }
  return response;
};

export const changeAccount = (account_id) => async (dispatch) => {
  const response = await setAccount(account_id);
  if (response.status === 'success') {
    dispatch(setAccountId(account_id));
  }
};

export const unchangeAccount = () => async (dispatch) => {
  const response = await unsetAccount();
  if (response.status === 'success') {
    dispatch(setAccountId(0));
  }
};
